<template>
    <div>
        <b-modal :title="$t('Jackpot')" hide-footer v-model="modal" centered>
            <div>
                {{
                    $t(
                        "Every week, the top inviters win a cash prize. Here's how it works."
                    )
                }}
            </div>

            <div class="mt-3">
                <div class="mb-3">
                    <strong>
                        <font-awesome-icon
                            icon="fa-duotone fa-trophy"
                            class="mr-1 text-warning"
                        />
                        {{ $t("Weekly prize") }}
                    </strong>
                    <div class="small text-secondary">
                        {{
                            $t(
                                "The jackpot is paid out at the end of every week. The top inviters win, and credits go straight to their wallet."
                            )
                        }}
                    </div>
                </div>

                <div class="mb-3">
                    <strong>
                        <font-awesome-icon
                            icon="fa-duotone fa-coins"
                            class="mr-1 text-warning"
                        />
                        {{ $t("Earn points by inviting") }}
                    </strong>
                    <div class="small text-secondary">
                        {{
                            $t(
                                "Every invite reward you earn counts as 1 point. More rewards means more points, which means a higher chance to win."
                            )
                        }}
                    </div>
                </div>

                <div class="mb-3">
                    <strong>
                        <font-awesome-icon
                            icon="fa-duotone fa-user-plus"
                            class="mr-1 branded"
                        />
                        {{ $t("Invite customers and creators") }}
                    </strong>
                    <div class="small text-secondary">
                        {{
                            $t(
                                "You earn rewards when customers you invite buy credits, and when creators you invite withdraw. Every reward counts toward the jackpot."
                            )
                        }}
                    </div>
                </div>

                <div class="mb-3">
                    <strong>
                        <font-awesome-icon
                            icon="fa-duotone fa-sitemap"
                            class="mr-1 branded"
                        />
                        {{ $t("Your invites keep paying off") }}
                    </strong>
                    <div class="small text-secondary">
                        {{
                            $t(
                                "The people you invite keep earning you rewards every week. The more you invite, the better your chances get — not just now, but for every jackpot going forward."
                            )
                        }}
                    </div>
                </div>

                <div>
                    <strong>
                        <font-awesome-icon
                            icon="fa-duotone fa-lightbulb"
                            class="mr-1 text-warning"
                        />
                        {{ $t("Tip") }}
                    </strong>
                    <div class="small text-secondary">
                        {{
                            $t(
                                "Check the leaderboard to see who's winning this week and how many points they have."
                            )
                        }}
                    </div>
                </div>
            </div>

            <div v-if="onboardingUser.creator" class="mt-3">
                <creator-invite-guides />
            </div>
        </b-modal>

        <b-btn
            @click="modal = true"
            variant="light"
            pill
            class="border"
            size="sm"
        >
            <font-awesome-icon icon="fa-duotone fa-info-circle" />
            {{ $t("How to Win") }}
        </b-btn>
    </div>
</template>


<script>
import { mapState } from "vuex";

import CreatorInviteGuides from "@/components/creator/guide/view/CreatorInviteGuides";

export default {
    data() {
        return {
            modal: false,
        };
    },
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    components: {
        CreatorInviteGuides,
    },
};
</script>